module.exports = __webpack_public_path__ + "media/niacinamide-medium.b00b0f89.mp4";